import React from 'react';
import baniere from '../img/telephone.png';  
import '../styles/telephone.css';

export default function Telephone (props){

  return (
        <div className="contact-block-container">
        <a className="link linkcss" href="tel:0891150473">
        <div className="contact-block">
            
            <div className="telephone-image">
            <img decoding="async" id="phone-banner" className="banniere" src={baniere} alt="0891 150 473"/>
            </div>
            <span className="ouverture"><i className="fa fa-circle"></i> Ouvert aujourd'hui de 8h à 18h</span><br/><span className="service">Service fourni par aide-sociale.fr</span>
        </div>
        </a>
    </div>
  );
};
